import React, { useState, useEffect } from "react";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { color } from "framer-motion";

const Section = ({ title, items, customContent, setModalUrl, isEmbeddable }) => {
  const [open, setOpen] = useState(false);


  return (
   <div className="mb-4">
      
      <div
        onClick={() => setOpen(!open)}
        className="d-flex justify-content-between align-items-center cursor-pointer bg-warning p-3 rounded shadow-sm"
      >
        <h4 className="text-lg font-semibold">{title}
          &nbsp; <span className="text-xl">{open ? "🔼" : "🔽"}</span>
        </h4>
      </div>
      {open && (
        <div className="mt-2 pl-6 text-sm">
         {items ? (
            <ul className="list-unstyled">
              {items.map((item, index) => (
                <li key={index} className="text-gray-800">
                  <button
                    onClick={() => {
                      if (item && item.url) {
                        if (isEmbeddable(item.url)) {
                          setModalUrl(item.url);
                        } else {
                          window.open(item.url, '_blank');
                        }
                      }
                    }}
                    className="btn btn-success my-2"
                  >
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            customContent || <p className="text-gray-500">माहिती उपलब्ध नाही</p>
          )}

        </div>
      )}
    </div>
  );
};

const WindowDetails = ({ gaonSrNo }) => {
  const [villageData, setVillageData] = useState(null);
  const [error, setError] = useState(null);
  const [modalUrl, setModalUrl] = useState(null);


  useEffect(() => {
    if (!gaonSrNo) return;

    axios
      .get('https://mazagaon.co.in/api/get-village-details.php', {
        params: { sr_no: gaonSrNo },
      })
      .then((response) => {
        console.log('✅ Village data:', response.data);
        if (response.data.error) {
          setError('डेटा सापडला नाही');
          setVillageData(null);
        } else {
          setVillageData(response.data);
        }
      })
      .catch((err) => {
        console.error('❌ Error fetching data:', err);
        setError('डेटा मिळवण्यात अडचण आली');
      });
  }, [gaonSrNo]);

  const arzList = [
    // {label: "मंजूर नोंदणी अर्ज | मजूर नोंदणी रजिस्टर ला आपले नाव तपासा", url: "https://mazagaon.co.in/pdfs/link1"},
   {label: "अर्ज नमुना", url: "https://mazagaon.co.in/pdfs/दाखले_अर्ज_नमुना.pdf"},
   {label: "अर्जा सोबत जोडवायची कागदपत्रांची यादी", url: "https://mazagaon.co.in/pdfs/अर्जासोबत_जोडावयाच्या_कागदपत्रांची_यादी.pdf"},
   {label: "बांधकाम परवानगी", url: "https://mazagaon.co.in/pdfs/बांधकाम_परवानगी_अर्ज.pdf"},
   {label: "बांधकाम परवानगी  (ऑनलाईन)", url: `https://mazagaon.co.in/forms/showform.php?fsno=11&gaonSr_No=${gaonSrNo}`},
   {label: "जन्म नोंद दाखला मागणी अर्ज (ऑनलाईन)", url: `https://mazagaon.co.in/forms/showform.php?fsno=1&gaonSr_No=${gaonSrNo}`},
   {label: "मृत्यू नोंद दाखला मागणी अर्ज (ऑनलाईन)", url: `https://mazagaon.co.in/forms/showform.php?fsno=2&gaonSr_No=${gaonSrNo}`},
   {label: "विवाह नोंदणी दाखल्यासाठी अर्ज (ऑनलाईन)", url: `https://mazagaon.co.in/forms/showform.php?fsno=3&gaonSr_No=${gaonSrNo}`},
   {label: "नमुना नं ०८ मागणी अर्ज (ऑनलाईन)", url: `https://mazagaon.co.in/forms/showform.php?fsno=4&gaonSr_No=${gaonSrNo}`},
   {label: "फेरफार नोंदणी अर्ज (ऑनलाईन)", url: `https://mazagaon.co.in/forms/showform.php?fsno=5&gaonSr_No=${gaonSrNo}`},
   {label: "माहितीचा अधिकार अंतर्गत अर्जाचा नमुना", url: "https://mazagaon.co.in/pdfs/माहितीचा-अधिकार-अंतर्गत-अर्जाचा-नमुना-जोडपत्र-अ.pdf"},
   {label: "नमुना नं. ०४ काम मागणी अर्ज (ऑनलाईन)", url: `https://mazagaon.co.in/forms/showform.php?fsno=6&gaonSr_No=${gaonSrNo}`},
   {label: "व्यवसाय ना हरकत दाखला अर्ज (ऑनलाईन)", url: `https://mazagaon.co.in/forms/showform.php?fsno=8&gaonSr_No=${gaonSrNo}`},
   {label: "दारिद्रय रेषा दाखला मागणी अर्ज (ऑनलाईन)", url: `https://mazagaon.co.in/forms/showform.php?fsno=9&gaonSr_No=${gaonSrNo}`},
   {label: "रहिवाशी दाखला मागणी अर्ज (ऑनलाईन)", url: `https://mazagaon.co.in/forms/showform.php?fsno=10&gaonSr_No=${gaonSrNo}`},
   {label: "ऑनलाइन दाखले मिळविणीसाठी इथे क्लिक करा.", url: "https://www.serviceonline.gov.in/citizenRegistration.html"},
  ];

  const declarationList = [
   {label: "रहिवाशी स्वयंघोषणापत्र", url: "https://mazagaon.co.in/pdfs/रहिवाशी_दाखला_स्व_घोषणापत्र.pdf"},
   {label: "वीज जोडणी स्वयंघोषणापत्र", url: "https://mazagaon.co.in/pdfs/वीज-जोडणी-स्वयंघोषणापत्र.pdf"},
   {label: "शौचालय असल्याबाबत स्वयंघोषणापत्र", url: "https://mazagaon.co.in/pdfs/शौचालय-असल्याबाबत-स्वयंघोषणापत्र.pdf"},
   {label: "हयात असल्याबाबत स्वयंघोषणापत्र", url: "https://mazagaon.co.in/pdfs/हयात-असल्याबाबत-स्वयंघोषणापत्र.pdf"},
   {label: "विधवा असल्याबाबत स्वयंघोषणापत्र", url: "https://mazagaon.co.in/pdfs/विधवा-असल्याबाबत-स्वयंघोषणापत्र-1.pdf"},
   {label: "परित्यक्त्या असल्याबाबत स्वयंघोषणापत्र", url: "https://mazagaon.co.in/pdfs/परितक्या-असल्याबाबत-स्वयंघोषणापत्र.pdf"},
   {label: "विभक्त कुटुंब असल्यास स्वयंघोषणापत्र", url: "https://mazagaon.co.in/pdfs/विभक्त-कुटुंब-असल्यास-स्वयंघोषणापत्र.pdf"},
   {label: "कोणत्याही योजनेचा लाभ न घेतल्याचे स्वयंघोषणापत्र", url: "https://mazagaon.co.in/pdfs/कोणत्याही-योजनेचा-लाभ-न-घेतल्याचे-स्वयंघोषणापत्र.pdf"},
  ];

  const certificateList = [
   {label:  "जातीचा दाखला अर्ज", url: "https://mazagaon.co.in/pdfs/जातीचा_फॉर्म.pdf"},
   {label:  "अल्पभूधारक फॉर्म", url: "https://mazagaon.co.in/pdfs/अल्पभूधारक_फॉर्म.pdf"},
   {label:  "वय व अधिवास प्रमाणपत्र अर्ज", url: "https://mazagaon.co.in/pdfs/Domocail_From.pdf"},
   {label:  "अल्प उत्पन्न गट प्रमाणपत्र अर्ज", url: "https://mazagaon.co.in/pdfs/EWS_ApplicationForm.pdf"},
  ];


  const complaintContent = (
    <div className="pt-4 space-y-2 text-gray-800">
      <p>तक्रार / सूचना नोंदवा :</p>
      <button
        onClick={() => setModalUrl(`https://mazagaon.co.in/forms/showform.php?fsno=12&gaonSr_No=${gaonSrNo}`)}
        className="btn btn-danger text-white bg-red-600 hover:bg-red-700 px-6 py-3 inline-block rounded shadow"
      >
        📝 तक्रार / सूचना
      </button>

      <p className="pt-2">
        आपण हा फॉर्म भरून आपली तक्रार, सूचना आपल्या ग्रामपंचायत ला कळवू शकता
      </p>
      <p className="text-xs text-gray-600">
        * Note: यापैकी जे ग्रामपंचायतीच्या अखत्यारीत आहे त्याची नक्कीच दखल घेतली जाईल. आपली तक्रार, सूचना किंवा माहिती दखलपात्र असल्यास आपणांस व्हाट्सऍप क्र. किंवा इमेल वर कळविले जाईल.
      </p>
    </div>
  );

  const adhikariContent = villageData ? (
    <div className="pt-4 space-y-4 text-gray-800">
      <div  className="card shadow w-full rounded-lg overflow-hidden">
        
        <h3>{villageData.adhikari_name}</h3>
        <div className="card-body p-4">
          <img
            src={`https://mazagaon.co.in/${villageData.gaon_name}/img/gpadhikari.jpg`}
            alt='grampanchayat adhikari'
            className="w-100"
          />
          <p className="text-sm">ग्रामपंचायत अधिकारी</p>
        </div>
      </div>

      <div  className="card shadow w-full rounded-lg overflow-hidden">
        <h3>कर वसुली आढावा</h3>
        <div className="card-body p-4">
          <img
            src={`https://mazagaon.co.in/${villageData.gaon_name}/img/tax_rate.jpg`}
            alt='previous year tax details'
            className="w-100"
          />
        </div>
      </div>
       <hr/>
          <section className="section">
            <h2>📄 वार्षिक अहवाल</h2>

            <div className="card">
              <h4>नमुना नं. - ३</h4>

              <a
                href="https://musalgaon.co.in//namuna3.pdf"
                target="_blank"
                rel="noopener noreferrer"
                download
                className="btn btn-success"
                style={{ color: "white" }}
              >
                📥 PDF डाउनलोड करा
              </a>
            </div>
          </section>

          <hr/>

      
    </div>
    
  ) : (
    <p className="text-sm text-gray-500">कर भरणा माहिती लोड होत आहे...</p>
  );

  const taxContent = villageData ? (
    <div className="pt-4 space-y-4 text-gray-800">
      {[
        {
          title: 'घरपट्टी जमा करणे कामी स्कॅनर',
          img: `https://mazagaon.co.in/${villageData.gaon_name}/img/taxes/gharpatti.jpg`,
          caption: 'स्कॅनर वर क्लिक करून तुमचा घरपट्टी कर भरा',
        },
        {
          title: 'पाणीपट्टी जमा करणे कामी स्कॅनर',
          img: `https://mazagaon.co.in/${villageData.gaon_name}/img/taxes/panipatti.jpg`,
          caption: 'स्कॅनर वर क्लिक करून तुमचा पाणीपट्टी कर भरा',
        }
      ].map((card, index) => (
        <div key={index} className="card shadow w-full rounded-lg overflow-hidden">
          <div className="card-body p-4">
            <h4 className="card-title text-lg font-semibold mb-2">{card.title}</h4>
            <img
              src={card.img}
              alt={card.title}
              className="w-full h-auto rounded-md mb-2"
            />
            <p className="text-sm">{card.caption}</p>
          </div>
        </div>
      ))}
    </div>

    ) : (
    <p className="text-sm text-gray-500">कर भरणा माहिती लोड होत आहे...</p>
  );

  const isEmbeddable = (url) => {
    return !(url.includes('docs.google.com') || url.endsWith('.pdf'));
  };
  
  return (
    <div className="py-2">
      {modalUrl && (
        <div className="modal-container">
          <div className="modal-content">
            <button
              className="close-button"
              onClick={() => setModalUrl(null)}
            >X
            </button>
            <iframe
              src={modalUrl}
              className="w-100"
              style={{ height: '80vh' }}
              title="Embedded Page"
            ></iframe>
          </div>
        </div>
      )}

      {adhikariContent} 
      {error && <p className="text-red-600 mb-4">{error}</p>}
      <Section title="कर भरणा" customContent={taxContent} items={null} setModalUrl={setModalUrl} isEmbeddable={isEmbeddable} />
      <Section title="अर्ज" items={arzList} setModalUrl={setModalUrl} isEmbeddable={isEmbeddable}/>
      <Section title="स्वयं घोषणापत्र" items={declarationList} setModalUrl={setModalUrl} isEmbeddable={isEmbeddable}/>
      <Section title="दाखले" items={certificateList} setModalUrl={setModalUrl} isEmbeddable={isEmbeddable}/>
      <Section title="तक्रार / सूचना " customContent={complaintContent} setModalUrl={setModalUrl} isEmbeddable={isEmbeddable}/>
    </div>
  );
};

export default WindowDetails;
